import { render, staticRenderFns } from "./InputAreaModify.vue?vue&type=template&id=35048b8e"
import script from "./InputAreaModify.vue?vue&type=script&lang=js"
export * from "./InputAreaModify.vue?vue&type=script&lang=js"
import style0 from "./InputAreaModify.vue?vue&type=style&index=0&id=35048b8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports